import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const TRANSLATIONS = {
  home_and_studio: I18n.t('react.search.filters.location.home_and_studio'),
  studio: I18n.t('react.search.filters.location.studio'),
  home: I18n.t('react.search.filters.location.home'),
  webcam: I18n.t('react.search.filters.location.webcam')
}

const LocationType = () => {
  const { nextPage, setLocationType } = useActions(sceneLogic)
  const { locationType } = useValues(sceneLogic)

  const updateLocationTypeAndProceed = locationType => {
    setLocationType(locationType)
    nextPage()
  }

  return (
    <div className='list-choice'>
      <h1>{I18n.t('react.request.location_type.title')}</h1>
      <ul className='clickable-list'>
        {Object.keys(TRANSLATIONS).map(key => (
          <li
            key={key}
            onClick={() => updateLocationTypeAndProceed(key)}
            className={locationType === key ? 'selected' : null}
          >
            {TRANSLATIONS[key]}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LocationType
